import React from "react";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";

interface Props {
  selectedBusinessReport: BusinessReport | null;
  businessReport: BusinessReport;
  handleTemplateSelect: (businessReport: BusinessReport) => void;
}

export const BusinessReportRow: React.FC<Props> = ({
  handleTemplateSelect,
  businessReport,
  selectedBusinessReport,
}) => (
  <div
    key={businessReport.id}
    className={`mb-2 cursor-pointer rounded p-2 ${
      selectedBusinessReport?.id === businessReport.id ? "bg-blue-100" : "hover:bg-gray-100"
    }`}
    onClick={() => handleTemplateSelect(businessReport)}
  >
    {businessReport.name}
  </div>
);
